import logo from '../logo.svg';
import '../App.css';
import { NavLink } from 'react-router-dom';
import { useEffect } from "react";
import PureCounter from "@srexi/purecounterjs";

function About() {
  useEffect(() => {
    new PureCounter();
  }, []);
  return (
    <>
        <div className="page-title">
          <div className="heading">
            <div className="container">
              <div className="row d-flex justify-content-center text-center">
                <div className="col-lg-8">
                  <h1 className="heading-title">About</h1>
                  <p className="mb-0">
                    Odio et unde deleniti. Deserunt numquam exercitationem. Officiis quo
                    odio sint voluptas consequatur ut a odio voluptatem. Sit dolorum
                    debitis veritatis natus dolores. Quasi ratione sint. Sit quaerat
                    ipsum dolorem.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <nav className="breadcrumbs">
            <div className="container">
              <ol>
                <li><NavLink to="/">Home</NavLink></li>
                <li className="current">About</li>
              </ol>
            </div>
          </nav>
        </div>

        <section id="about" className="about section">

          <div className="container" data-aos="fade-up" data-aos-delay="100">

            <div className="row align-items-center">
              <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                <div className="about-content">
                  <h2>Compassionate Care for Every Family</h2>
                  <p className="lead">For over two decades, we have been dedicated to providing exceptional healthcare services
                    to our community. Our commitment goes beyond medical treatment—we believe in building lasting
                    relationships with our patients and their families.</p>

                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                    dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                    ex ea commodo consequat.</p>

                  <div className="stats-grid">
                    <div className="stat-item">
                      <span className="stat-number" data-purecounter-start="0" data-purecounter-end="15000"
                        data-purecounter-duration="2">15000</span>
                      <span className="stat-label">Patients Treated</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number" data-purecounter-start="0" data-purecounter-end="25"
                        data-purecounter-duration="2">25</span>
                      <span className="stat-label">Years Experience</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-number" data-purecounter-start="0" data-purecounter-end="50"
                        data-purecounter-duration="2">50</span>
                      <span className="stat-label">Medical Specialists</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
                <div className="image-wrapper">
                  <img src="assets/img/health/facilities-6.webp" className="img-fluid main-image" alt="Healthcare facility" />
                  <div className="floating-image" data-aos="zoom-in" data-aos-delay="400">
                    <img src="assets/img/health/staff-8.webp" className="img-fluid" alt="Medical team" />
                  </div>
                </div>
              </div>
            </div>

            <div className="values-section" data-aos="fade-up" data-aos-delay="300">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h3>Our Core Values</h3>
                  <p className="section-description">These principles guide everything we do in our commitment to exceptional
                    healthcare</p>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="bi bi-heart-pulse"></i>
                    </div>
                    <h4>Compassion</h4>
                    <p>Providing care with empathy and understanding for every patient's unique needs and circumstances.</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="bi bi-shield-check"></i>
                    </div>
                    <h4>Excellence</h4>
                    <p>Maintaining the highest standards of medical care through continuous learning and innovation.</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="bi bi-people"></i>
                    </div>
                    <h4>Integrity</h4>
                    <p>Building trust through honest communication and ethical practices in all our interactions.</p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">
                  <div className="value-item">
                    <div className="value-icon">
                      <i className="bi bi-lightbulb"></i>
                    </div>
                    <h4>Innovation</h4>
                    <p>Embracing cutting-edge technology and treatments to improve patient outcomes.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="certifications-section" data-aos="fade-up" data-aos-delay="400">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h3>Accreditations &amp; Certifications</h3>
                  <p className="section-description">Recognized by leading healthcare organizations for our commitment to
                    quality care</p>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="100">
                  <div className="certification-item">
                    <img src="assets/img/clients/clients-1.webp" className="img-fluid" alt="Healthcare certification" />
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="200">
                  <div className="certification-item">
                    <img src="assets/img/clients/clients-2.webp" className="img-fluid" alt="Medical accreditation" />
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="300">
                  <div className="certification-item">
                    <img src="assets/img/clients/clients-3.webp" className="img-fluid" alt="Healthcare certification" />
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="400">
                  <div className="certification-item">
                    <img src="assets/img/clients/clients-4.webp" className="img-fluid" alt="Medical certification" />
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="500">
                  <div className="certification-item">
                    <img src="assets/img/clients/clients-5.webp" className="img-fluid" alt="Healthcare accreditation" />
                  </div>
                </div>
              </div>
            </div>

          </div>

        </section>
    </>
  );
}

export default About;
